<template>
    <vx-prompt
        :title="title"
        color="primary"
        class="prompt"
        :active.sync="localActive"
        :accept-text="`Upload (${uploads.length})`"
        :isValid="uploads.length >= requireCount"
        prevent-close-on-accept
        @accept="upload"
        @cancel="close"
        @close="close"
    >
        <slot></slot>
        <vx-file-upload
            v-model="uploads"
            class="mt-2"
            :allowTypes="allowTypes"
            :text="text"
            :maxText="maxText"
            :limit="limit"
        />
    </vx-prompt>
</template>

<script>
export default {
    name: 'vx-upload-popup',
    props: {
        active: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: 'Upload'
        },
        text: {
            type: String,
            default: 'Upload File'
        },
        maxText: {
            type: String,
            default: 'File Limit Reached'
        },
        requireCount: {
            type: [Number],
            default: 1
        },
        limit: {
            type: [Number, String],
            default: null
        },
        allowTypes: {
            type: [String, Array],
            default: () => []
        },
        automatic: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            uploads: []
        }
    },
    computed: {
        localValue: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        },
        localActive: {
            get() {
                return this.active
            },
            set(val) {
                //console.log('trying to set localActive = ' + val)
            }
        }
    },
    methods: {
        close() {
            this.$emit('update:active', false)
            this.$emit('close')
            this.uploads = []
        },
        async upload() {
            this.startLoad('.prompt .vs-dialog')
            try {
                if (this.automatic) {
                    var uploadTasks = this.uploads.map((file) => {
                        return this.$api.resources.create(file.file).then((val) => {
                            this.$emit('fileUploaded', { base64: file.base64, resource: val })
                        })
                    })
                    await Promise.all(uploadTasks)
                } else {
                    // Allows bound listener to run synchronously before
                    // the prompt is closed
                    if (this.$listeners['fileUploaded']) {
                        var externalUploadTasks = this.uploads.map((file) => {
                            return this.$listeners['fileUploaded'](file)
                        })
                        if (externalUploadTasks) {
                            await Promise.all(externalUploadTasks.where((t) => t && t.then))
                        }
                    }
                }
                this.close()
            } catch (err) {
                this.notifyServerError(err)
                // this.notifyError(
                //     'Upload Failed',
                //     'An error occurred while trying to complete your request.\n Please check your internet and try again.'
                // )
            } finally {
                this.endLoad('.prompt .vs-dialog')
            }
        }
    }
}
</script>

<style scoped>
.vx-file-upload {
    height: 280px;
}
</style>
